import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-table-modal',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatTableModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './table-modal.component.html',
  styleUrls: ['./table-modal.component.css'],
})
export class TableModalComponent implements OnInit {
  _title: string; // Título do modal
  headers: { [key: string]: string }; // Armazena os títulos customizados
  columns: string[]; // Apenas os nomes das colunas
  rows: any[];
  _paginaAtual = 0;
  _ultimaPagina = false;
  _isLoading = false;
  _dataKey: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TableModalComponent>
  ) {}

  ngOnInit(): void {
    this._title = this.data.title;
    this.headers = this.data.headers;
    this.columns = Object.keys(this.headers);
    this.rows = this.data.rows;
    this._paginaAtual = this.data.paginaAtual || 0;
    this._ultimaPagina = this.data.ultimaPagina || false;
    this._dataKey = this.data.dataKey || 'rows';
  }

  proximaPagina(): void {
    if (this._ultimaPagina || this._isLoading) {
      return;
    }

    this._isLoading = true;
    this.data.fetchMore(this._paginaAtual + 1).subscribe(
      (response: any) => {
        if (response[this._dataKey]?.length === 0) {
          this._ultimaPagina = true;
        } else {
          this.rows = [...this.rows, ...response[this._dataKey]];
          this._paginaAtual++;
        }
        this._isLoading = false;
      },
      () => {
        this._isLoading = false;
      }
    );
  }

  close(): void {
    this.dialogRef.close({ confirm: false });
  }
}
